import {ActionLocal} from './actions.service';
import {Ic, IDesignSolution, ILedInfo} from '../../models/common';
import {type} from '../../common/utils';


export class ApplicationCatalogActions {

  static ActionType = {
    LOAD: type('[ApplicationCatalogActions] LOAD'),
    LOADED: type('[ApplicationCatalogActions] LOADED'),
    LOAD_COMPLETE: type('[ApplicationCatalogActions] LOAD_COMPLETE'),
    ACCEPT_SOLUTIONS: type('[ApplicationCatalogActions] ACCEPT_SOLUTIONS'),
    ORDER_SOLUTIONS: type('[ApplicationCatalogActions] ORDER_SOLUTIONS'),
    UPDATE_SOLUTIONS: type('[ApplicationCatalogActions] UPDATE_SOLUTIONS'),
    START_CALC_EFFICIENCY: type('[ApplicationCatalogActions] START_CALC_EFFICIENCY'),
    CALC_EFFICIENCY: type('[ApplicationCatalogActions] CALC_EFFICIENCY'),
    LOAD_ERROR: type('[ApplicationCatalogActions] LOAD_ERROR'),
    SELECT_SOLUTION: type('[ApplicationCatalogActions] SELECT_SOLUTION'),
    SELECT_SOLUTION_BY_KEY: type('[ApplicationCatalogActions] SELECT_SOLUTION_BY_KEY'),
    SET_DESIGN_SOLUTIONS: type('[ApplicationCatalogActions] SET_DESIGN_SOLUTIONS'),
    SET_LED_DB: type('[ApplicationCatalogActions] SET_LED_DB'),
    LOAD_DESCRIPTIONS_OF_SELECTED_SOLUTION: type('[ApplicationCatalogActions] LOAD_DESCRIPTIONS_OF_SELECTED_SOLUTION'),
    LOADED_DESCRIPTIONS_OF_SELECTED_SOLUTION: type('[ApplicationCatalogActions] LOADED_DESCRIPTIONS_OF_SELECTED_SOLUTION'),
    LOADED_DESCRIPTIONS_OF_SELECTED_SOLUTION_ERROR: type('[ApplicationCatalogActions] LOADED_DESCRIPTIONS_OF_SELECTED_SOLUTION_ERROR'),
  };

  public static loadCatalog(appClass: string, catalogName: string, topologies: string[]): ActionLocal {
    return {
      type: ApplicationCatalogActions.ActionType.LOAD,
      payload: {appClass: appClass, name: catalogName, topologiesFilter: topologies}
    };
  }

  public static loadedCatalog(catalog: Ic[]): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.LOADED, payload: catalog};
  }

  public static loadComplete(): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.LOAD_COMPLETE};
  }

  public static loadCatalogError(error: string): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.LOAD_ERROR, payload: error};
  }

  public static selectSolution(ic: Ic): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.SELECT_SOLUTION, payload: ic};
  }

  public static deselectSolution(): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.SELECT_SOLUTION_BY_KEY, payload: null};
  }

  public static selectSolutionByKey(key: string): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.SELECT_SOLUTION_BY_KEY, payload: key};
  }

  public static setDesignSolutions(a: IDesignSolution[]): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.SET_DESIGN_SOLUTIONS, payload: a};
  }

  public static setLedDB(a: ILedInfo[]): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.SET_LED_DB, payload: a};
  }

  public static acceptSolutions(): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.ACCEPT_SOLUTIONS};
  }

  public static orderSolutions(): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.ORDER_SOLUTIONS};
  }

  public static updateSolutions(a: IDesignSolution[]): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.UPDATE_SOLUTIONS, payload: a};
  }

  public static start_calculate_efficiency(): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.START_CALC_EFFICIENCY};
  }

  public static calculate_efficiency(a: IDesignSolution[]): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.CALC_EFFICIENCY, payload: a};
  }

  public static loadedDescriptionsOfSelectedSolution(descriptions: any): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.LOADED_DESCRIPTIONS_OF_SELECTED_SOLUTION, payload: descriptions};
  }

  public static loadedDescriptionsOfSelectedSolutionError(error: string): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.LOADED_DESCRIPTIONS_OF_SELECTED_SOLUTION_ERROR, payload: error};
  }

  public static loadDescriptionsOfSelectedSolution(ic: Ic): ActionLocal {
    return {type: ApplicationCatalogActions.ActionType.LOAD_DESCRIPTIONS_OF_SELECTED_SOLUTION, payload: ic};
  }
}
